import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/Home/Home';
import AboutUs from "./pages/About/AboutUs";
import ContactUs from './pages/Contact/ContactUs';
import Services from './pages/Services/Services';
import Adoption from './pages/Adoption/Adoption';
import Trainers from './pages/Trainers/Trainers';
import Dashboard from './pages/Dashboard/Dashboard';
import ServicesListing from './pages/ServicesListing/ServicesListing';
import PetRegistration from './pages/PetRegistration/PetRegistration';
import Fostering from './pages/Fostering/Fostering';
import Groomers from './pages/Groomers/Groomers';
import Veterinary from './pages/Veterinary/Veterinary';
import Walkers from './pages/Walkers/Walkers';
import PetFood from './pages/PetFood/PetFood';
import PetEvents from './pages/PetEvents/PetEvents';
import Community from './pages/Community/Community';
import PageHeader from "./pages/Header";
import PageFooter from "./pages/Footer"
import { getAssetPath } from './services/helpers';
import ScrollToTop from './ScrollToTop';
import RegistrationModal2 from './components/RegistrationModal2';
import YourStory from './pages/YourStory/YourStory';

function App() {
    const routerBasename = process.env.REACT_APP_ROUTER_BASENAME || "/";
    return (
        <Router basename={routerBasename}>
            <div className="App">
                <ScrollToTop />
                <PageHeader />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/AboutUs" element={<AboutUs />} />
                     <Route path="/Adoption" element={<Adoption />} />
                     <Route path="/Trainers" element={<Trainers />} />
                     <Route path="/Services" element={<Services />} />
                     <Route path="/ServicesListing" element={<ServicesListing />} />
                     <Route path="/PetRegistration" element={<PetRegistration />} />
                     <Route path="/fostering-pet-sitters" element={<Fostering />} />
                     <Route path="/groomers" element={<Groomers />} />
                     <Route path="/veterinary-services" element={<Veterinary />} />
                     <Route path="/walkers" element={<Walkers />} />
                     <Route path="/pet-food-accessories" element={<PetFood />} />
                     <Route path="/pet-events" element={<PetEvents />} />
                     <Route path="/community-forum" element={<Community />} />
                     <Route path="/ContactUs" element={<ContactUs />} />
                     <Route path="/YourStory" element={<YourStory />} />
                </Routes>

                <PageFooter />
                <RegistrationModal2 />
                <ToastContainer position="top-right" autoClose={3000} />
            </div>
        </Router>
    );
}

export default App;